import React, { Fragment, useEffect, useState } from 'react';
import T from 'prop-types';
import { Platform, View } from 'react-native';

import { moderateScale } from '../../../utils/scaleHelpers';
import ConditionalRender from '../ConditionalRender';
import { StyledScrollView } from '../Wrappers';
import { StyledView } from './styledComponents';

const ChildComponent = ({
  children,
  FooterComponent,
  footerProps,
  HeaderComponent,
  headerProps,
  style = {},
}) => {
  const [mount, setMount] = useState(Platform.OS !== 'android'); // mount immediately on non-Android

  const styleRadius = HeaderComponent ? {} : {
    borderTopLeftRadius: moderateScale(16),
    borderTopRightRadius: moderateScale(16),
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    // Delay helps ensure Modal/Drawer is fully rendered on Android
    if (Platform.OS === 'android') {
      const timeout = setTimeout(() => setMount(true), 200);
      return () => clearTimeout(timeout);
    }
  }, []);

  if (!mount) return <View />; // Prevent premature render

  return (
    <Fragment>
      <ConditionalRender
        Component={HeaderComponent}
        propsToPassDown={headerProps}
        shouldRender={!!HeaderComponent}
      />
      <StyledScrollView style={styleRadius}>
        <StyledView onStartShouldSetResponder={() => true} style={style}>
          {children}
        </StyledView>
      </StyledScrollView>
      <ConditionalRender
        Component={FooterComponent}
        propsToPassDown={footerProps}
        shouldRender={!!FooterComponent}
      />
    </Fragment>
  );
};

ChildComponent.propTypes = {
  children: T.node.isRequired,
  FooterComponent: T.elementType,
  footerProps: T.object,
  HeaderComponent: T.elementType,
  headerProps: T.object,
  style: T.oneOfType([T.object, T.array]),
};

export default ChildComponent;
